import {
  GET_ORIGINS_ATTEMPT,
  GET_ORIGINS_SUCCESS,
  GET_ORIGINS_FAILURE,
} from "../constants";

import { OriginsInitialState } from "../../types/origins";

const initialState: OriginsInitialState = {
  fetchingOriginsList: 0,
  errorMessage: "",
  success: true,
  originsList: [],
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    // getRegions
    case GET_ORIGINS_ATTEMPT:
      return {
        ...state,
        fetchingOriginsList: state.fetchingOriginsList + 1,
        success: true,
        errorMessage: "",
      };
    case GET_ORIGINS_SUCCESS:
      return {
        ...state,
        fetchingOriginsList: state.fetchingOriginsList - 1,
        success: true,
        errorMessage: "",
        originsList: action.payload.data,
      };
    case GET_ORIGINS_FAILURE:
      return {
        ...state,
        fetchingOriginsList: state.fetchingOriginsList - 1,
        success: false,
        errorMessage: action.payload.error,
      };

    default:
      return state;
  }
};
